import React, { lazy, Suspense } from 'react';
import './css-dynamic.less';

const Animation1 = lazy(() => import(`./css-dynamic-component/animation1/animation1`));

const Animate2 = lazy(() => import('./css-dynamic-component/animation2/animate2'));

const Animate3 = lazy(() => import('./css-dynamic-component/animation3/animate3'));

const Animate4 = lazy(() => import('./css-dynamic-component/animation4/animate4'));

const Animate5 = lazy(() => import('./css-dynamic-component/animation5/animate5'));

const Animate6 = lazy(() => import('./css-dynamic-component/animation6/animate6'));

const Animate7 = lazy(() => import('./css-dynamic-component/animation7/animate7'));

const Animate8 = lazy(() => import('./css-dynamic-component/animation8/animate8'));

const CssDynamic: React.FC<{ name: string }> = ({ name }) => {
    return (
        <div className="c-dynamic-bg-layer">
            {name === 'Animation1' ? (
                <Suspense fallback={<></>}>
                    <Animation1 />
                </Suspense>
            ) : name === 'Animate2' ? (
                <Suspense fallback={<></>}>
                    <Animate2 />
                </Suspense>
            ) : name === 'Animate3' ? (
                <Suspense fallback={<></>}>
                    <Animate3 />
                </Suspense>
            ) : name === 'Animate4' ? (
                <Suspense fallback={<></>}>
                    <Animate4 />
                </Suspense>
            ) : name === 'Animate5' ? (
                <Suspense fallback={<></>}>
                    <Animate5 />
                </Suspense>
            ) : name === 'Animate6' ? (
                <Suspense fallback={<></>}>
                    <Animate6 />
                </Suspense>
            ) : name === 'Animate7' ? (
                <Suspense fallback={<></>}>
                    <Animate7 />
                </Suspense>
            ) : name === 'Animate8' ? (
                <Suspense fallback={<></>}>
                    <Animate8 />
                </Suspense>
            ) : null}
        </div>
    );
};

export default CssDynamic;
